// Import the native module. On web, it will be resolved to Burnt.web.ts
// and on native platforms to Burnt.ts
import BurntModule from "./BurntModule";
export function alert({ duration = 5, ...options }) {
    return BurntModule.alertAsync({ duration, ...options });
}
export function toast({ duration = 5, ...options }) {
    return BurntModule.toastAsync({ duration, ...options });
}
export function dismissAllAlerts() {
    return BurntModule.dismissAllAlertsAsync();
}
//# sourceMappingURL=index.js.map